import { api } from '../api';
import { provider, tags } from '../tags';
import type { LevelUpRequest, operations } from '../types';

/* istanbul ignore file */

export type LevelUpArgs = operations['createLevelUpRequest']['parameters']['path'];

export const levelsApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    levelUp: builder.query<Array<LevelUpRequest>, LevelUpArgs>({
      query: ({ account_pk }) => `api/account/${account_pk}/levelup/`,
      providesTags: provider<LevelUpRequest>(tags.levelup, null),
    }),

    upgradeLevel: builder.mutation<LevelUpRequest, LevelUpArgs>({
      query: ({ account_pk }) => ({
        url: `api/account/${account_pk}/levelup/`,
        method: 'POST',
      }),
      invalidatesTags: (result, _error, args) =>
        result ? [tags.levelup, { type: tags.account, id: args.account_pk }] : [],
    }),
  }),
});
